import DynamicFormDefinitionModelBase from '../_generated/modelBases/dynamic-form-definition-model-base';

export default class DynamicFormDefinitionModel extends DynamicFormDefinitionModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
